// Centralized version configuration
// Update these values when releasing new versions

export const APP_VERSION = '3.1.0';
export const BUILD_DATE = 'Feb. 11, 2026';
export const COPYRIGHT_YEAR = '2026';
export const COMPANY_NAME = 'SiteOperations.io';
